const FooterLGPD = () => {
  return (
    <>
      <div className="border border-gray-200 p-3 text-xs text-gray-600 mt-10 text-justify bg-gray-100">
        <div className="font-semibold underline mb-1">
          Informações Importantes
        </div>
        <p>
          As informações apresentadas nesta consulta de crédito são
          confidenciais e destinam-se exclusivamente ao processo de análise,
          avaliação de risco e orientação em transações comerciais. Qualquer uso
          diverso, em desacordo com a legislação vigente, incluindo a Lei Geral
          de Proteção de Dados (Lei 13.709/18 - LGPD), poderá acarretar
          responsabilidade civil e criminal pelos danos eventualmente causados a
          terceiros. A responsabilidade da empresa que fornece esta consulta se
          limita à transmissão fiel dos dados obtidos em bases de dados públicas
          e privadas, disponibilizados por órgãos oficiais, bureaus de crédito e
          instituições conveniadas. As informações exibidas refletem o conteúdo
          disponível na data e hora da pesquisa. Em caso de divergência, omissão
          ou questionamento, recomenda-se que seja realizada a verificação
          diretamente com o credor, cartório, bureau de crédito ou órgão
          competente. A empresa declara estar ciente de que as informações
          apresentadas nesta consulta têm o objetivo de auxiliar na tomada de
          decisão de concessão de crédito, negociação ou verificação cadastral,
          servindo como instrumento de apoio e não como única base para a
          conclusão de operações financeiras. É importante ressaltar que os
          dados de crédito podem ser alterados, incluídos ou removidos em tempo
          real por instituições financeiras, bureaus, órgãos públicos e
          cartórios. Dessa forma, as informações aqui apresentadas podem não
          refletir imediatamente a atualização mais recente dos registros. As
          informações mencionadas são de uso exclusivo do destinatário
          autorizado, protegidas por sigilo contratual e restritas às
          finalidades de análise de crédito previamente pactuadas. Qualquer
          utilização por terceiros ou para objetivos não autorizados caracteriza
          ilícito civil, podendo invalidar o documento para efeitos processuais.
        </p>

        <div className="font-semibold mt-2 underline mb-1">
          Minuta de Declaração LGPD
        </div>
        <p>
          Declaro que a utilização dos dados obtidos por meio desta consulta
          respeitará as finalidades legítimas previstas em lei, bem como os
          princípios e procedimentos estabelecidos pela Lei Geral de Proteção de
          Dados (Lei 13.709/18 - LGPD), conforme divulgado em minha página
          inicial de acesso.
        </p>
      </div>
    </>
  );
};

export default FooterLGPD;
